import { FC, useEffect, useMemo, useState } from "react";
import { Row, Col, Button, Breadcrumb, Tooltip, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { DoubleRightOutlined } from "@ant-design/icons";
import { cloneDeep, forEach, findIndex, uniqBy, get } from "lodash";
import moment from "moment";

import Layout from "@layout/default";
import "./member-details.scss";
import Profile from "./profile";
// import { members } from "./profile/constants";
// import ModalComponent from "./modal";
// import ModalComponent from "./modal";
import memberDetailService from "@services/memberDetails.service";
import membersService from "@services/members.service";
import { MEMBERS_DETAILS_SCREEN_TITLE, routeMap } from "@utils/constants";
import { IMembers } from "@pages/members/constants";
// import moment from "moment";
import MemberTabsComponent from "./member-tabs";
import { centricClientCheck, formatDisplayDate, getClientName, milleniumClientCheck } from "@utils/helpers";
import { appInsights } from "../../appInsights";
import sessionService from "@services/session.service";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import Icon from "@assets/icon_config";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";
import PatientCaseStatusPopUp from "./patientCaseStatusPopUp/popUp";
import memberService from "@services/members.service";
import { useMemberListStore } from "@stores/useMemberListStore";
import { useDashboardStore } from "@stores/dashboardStore";
import memberDetailsService from "@services/memberDetails.service";
import CareCoordinationService from "@services/care-coordination";
import { useEolStore } from "@stores/eolStore";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";
import { CadenceStatus } from "@components/drawerOutreaches/Cadence";
import { useDropdowns, useHelperApiFunctions } from "@utils/customHooks";

const MemberProfile: FC<any> = () => {
  //Store state
  const setCurrentScreen = useGlobalInformationStore((state) => state.setCurrentScreen);
  const memberDetailListRegistryDropDown = useGlobalInformationStore((state) => state.memberDetailListRegistryDropDown);
  const setMemberDetailListRegistryDropDown = useGlobalInformationStore((state) => state.setMemberDetailListRegistryDropDown);
  const registryDependentMemberListPageStore = useMemberListStore((state) => state.registryDependentMemberListPageStore);
  const setMemberDetailClassificationValues = useGlobalInformationStore((state) => state.setMemberDetailClassificationValues);
  const globalPatientSearchText = useGlobalInformationStore((state) => state.globalPatientSearchText);
  const setUpdatedNotes = useCareCoordinationStore((state) => state.setUpdatedNotes);
  const setUpdatedReminder = useCareCoordinationStore((state) => state.setUpdatedReminder);
  // const patientData = usePatientProfileStore((state) => state.patientData);
  const clearPatientProfileStore = usePatientProfileStore((state) => state.clearStore);
  // const setMemberDetailsAttributedPcpNameLetest = usePatientProfileStore((state) => state.setMemberDetailsAttributedPcpNameLetest);
  // const setMemberDetailsAttributedOfficeNameLetest = usePatientProfileStore((state) => state.setMemberDetailsAttributedOfficeNameLetest);
  const [dod, setdod] = usePatientProfileStore((state) => [state.dod, state.setdod]);
  const [setRegistryDependentProgramsStatus] = usePatientProfileStore((state) => [state.setRegistryDependentProgramsStatus]);
  const [showLoader, setShowLoader] = usePatientProfileStore((state) => [state.memberPageLoader, state.setMemberPageLoader]);
  const nextFunc = useGlobalInformationStore((state) => state.nextFunc);
  const setPhysicianCarePlanNotes = useCareCoordinationStore((state) => state.setPhysicianCarePlanNotes);

  const [direction, setDirection] = useState<any>();
  const [count, setCount] = useState<any>(0);
  const [currentMember, changeCurrentMember] = useState<IMembers>();
  const adtState = useMemberListStore((state) => state.adtState);
  const setSelectedReport = useDashboardStore((state) => state.setSelectedReport);
  const [setEolData, setIsLoading, setEolList] = useEolStore((state) => [state.setEolData, state.setIsLoading, state.setEolList]);
  const [setMemberData, setMemberDetailLoader, setChronicsList] = useMemberDetailsStore((state) => [state.setMemberData, state.setMemberDetailLoader, state.setChronicsList]);
  const setPhysicianCarePlanResponse = useCareCoordinationStore((state) => state.setInitialResponse);
  const setMemberProfilePhysicianCarePlanLoader = useCareCoordinationStore((state) => state.setMemberProfilePhysicianCarePlanLoader);
  const isMillenium = milleniumClientCheck();
  const isCentric = centricClientCheck();

  //const [status, setStatus] = useState(1);
  const [closeCase, setCloseCase] = useState(false);
  const [collapsedProfile, setCollapsedProfile] = useState(false);
  const [patientCaseStatusOptions, setPatientCaseStatusOptions] = useState<any>();
  const [loadingForOverview, setOverviewLoaderFlag] = useState(false);
  const { notesLoader, getNotes } = useHelperApiFunctions();

  // const [showLoader, setShowLoader] = useState(false);
  //const [patientId, setPatientId] = useState(Number);

  // Notification state
  const [newNotificationFlag, setNewNotificationFlag] = useState(false);
  const [notificationsData, setNotificationsData] = useState<any>({});
  const [mainLoader, setMainLoader] = useState(false);
  const filteredInfo = useMemberListStore((state) => state.filteredInfo);
  //State for active tab
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [leftBtn, setLeftBtn] = useState(false);
  const [rightBtn, setRightBtn] = useState(false);

  const navigate = useNavigate();
  const location: any = useLocation();

  const patientCurrentStatus = useMemo(() => {
    return patientCaseStatusOptions?.find((item: any) => item.value === membersService?.getCurrentMember?.patient_case_status);
  }, [membersService?.getCurrentMember?.patient_case_status, patientCaseStatusOptions]);

  function callback(key: any) {
    console.log(key);
    setActiveTabKey(key);
  }

  const getMemberDetailRegistryList = () => {
    memberDetailsService.fetchAttributeDropdown("MemberDetailRegistryLst").subscribe({
      next: (response: any) => {
        const data = response?.data?.data?.data?.map((item: any) => {
          let tempDataItem = cloneDeep(item);
          tempDataItem = {
            ...tempDataItem,
            ...(tempDataItem?.optionalValue ? { optionalValue: JSON.parse(tempDataItem?.optionalValue) } : {}),
          };
          return tempDataItem;
        });
        setMemberDetailListRegistryDropDown(data);
        getRegistryDependentProgramsStatus();
        getMemberDetailClassificationValues();
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  };

  const getMemberDetailClassificationValues = () => {
    const patientId = membersService?.getCurrentMember?.patient_id;
    if (patientId) {
      memberDetailsService.fetchClassificationStatusList(patientId).subscribe({
        next: (response: any) => {
          setMemberDetailClassificationValues(response.data.data.result);
        },
        error: (error: any) => {
          console.log(error);
        },
      });
    }
  };

  const { loadingOptions, filterDropdowns, getOptions } = useDropdowns();

  useEffect(() => {
    console.log("MemberProfile.useEffect1");
    setMainLoader(true);
    const cMember = membersService?.getCurrentMember;
    setCurrentScreen(MEMBERS_DETAILS_SCREEN_TITLE);
    if (memberDetailListRegistryDropDown && memberDetailListRegistryDropDown?.length <= 0 && !isCentric) {
      getMemberDetailRegistryList();
    } else {
      getMemberDetailClassificationValues();
      getRegistryDependentProgramsStatus();
    }

    if (cMember && cMember?.patient_id) {
      changeCurrentMember(cMember);
      // let pId = parseInt(cMember?.patient_id);
      //setPatientId(cMember?.patientId);
      // getOverviewDetails(pId);

      getMemberDetails();
      getChronicsData();
      if (!isCentric) {
        getEolData();
      }
      if (isMillenium) {
        getNotes({
          isAllCM: true,
          memberId: cMember?.patient_id,
          filter: {
            startDate: null,
            endDate: null,
            type: "physician_care_plan_note",
          },
          isPaginationRequired: false,
          successCallBack: (notes: any) => {
            setPhysicianCarePlanNotes(notes);
          },
          failureCallBack: () => {
            setPhysicianCarePlanNotes([]);
          },
        });
      } else {
        physicianCarePlan();
      }
    } else {
      let url = new URL(window.location.href);
      if (url.search) {
        setMainLoader(true);
        membersService.memberDetails(url.search).subscribe({
          next: (v) => {
            const cMember = v.data?.data?.patientList?.pop();
            membersService.setCurrentMember = cMember;
            membersService.setsingleMember = false;
            changeCurrentMember(cMember);
            setMainLoader(false);
            // let pId = parseInt(cMember?.patient_id);
            //setPatientId(cMember?.patientId);
            // getOverviewDetails(pId);
          },
          error: (e) => {
            appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
            navigate(routeMap["members"]);
            setMainLoader(false);
          },
        });
      } else {
        appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
        navigate(routeMap["members"]);
      }
    }

    //Updating notes for drawer edit/deletion
    setUpdatedNotes({ editedNotes: [], deletedNotes: [] });
    setUpdatedReminder({ editedReminder: [], deletedReminder: [] });
    // eslint-disable-next-line react-hooks/exhaustive-deps

    if (!isCentric) {
      getOptions("PatientCaseStatusFilterLst");
      memberDetailsService?.fetchAttributeDropdown("PatientCaseStatusFilterLst").subscribe({
        next: (response: any) => {
          setPatientCaseStatusOptions(response.data.data.data);
        },
        error: (error) => {
          console.log(error);
        },
      });
    }
  }, [membersService?.getCurrentMember?.patient_id]);

  useEffect(() => {
    console.log("MemberProfile.useEffect2");
    if (notificationsData?.notifications?.length === 0) {
      fetchNotifications();
    }
  }, []);

  const getMemberDetails = () => {
    setMemberDetailLoader(true);
    memberDetailsService.getMemberDetailsRecords(membersService?.getCurrentMember?.patient_id).subscribe({
      next: (response) => {
        setMemberDetailLoader(false);
        setMemberData(response?.data?.data?.memberDetails);
      },
      error: (e) => {
        console.log(e);
        setMemberDetailLoader(false);
        setMemberData(null);
      },
    });
  };

  const getEolData = () => {
    setIsLoading(true);
    memberDetailsService.getEolRecords(membersService?.getCurrentMember?.patient_id).subscribe({
      next: (response) => {
        const data = response?.data?.data?.endOfLife?.values;
        setEolList(data);
        if (data?.length > 0) {
          let tempEOLHeader: any = ["Disease Name", "First Diagnosed Date", "Last Diagnosed Date"];
          let tempDiseaseName: any = [];
          let tempFirstDiagnosedDate: any = [];
          let tempLastDiagnosedDate: any = [];
          let tempFirstDiagnosisDayspast: any = [];
          let tempLastDiagnosisDayspast: any = [];

          data?.forEach((dataItem: any) => {
            tempDiseaseName.push(dataItem.disease_description);
            tempFirstDiagnosedDate.push(dataItem.first_diagnosis_date);
            tempLastDiagnosedDate.push(dataItem.last_dianosis_date);
            tempFirstDiagnosisDayspast.push(dataItem.first_diagnosis_dayspast);
            tempLastDiagnosisDayspast.push(dataItem.last_diagnosis_dayspast);
          });

          const tempEolData = {
            eolHeader: tempEOLHeader,
            diseaseName: tempDiseaseName,
            firstDiagnosedDate: tempFirstDiagnosedDate,
            lastDiagnosedDate: tempLastDiagnosedDate,
            totalEOLCnt: data[0]?.terminal_disease_count,
            isDataFound: true,
            firstDiagnosisDayspast: tempFirstDiagnosisDayspast,
            lastDiagnosisDayspast: tempLastDiagnosisDayspast,
            patientId: membersService?.getCurrentMember?.patient_id,
          };
          setEolData(tempEolData);
        } else {
          setEolData({ isDataFound: false });
        }
        setIsLoading(false);
      },
      error: (e) => {
        console.log(e);
        setIsLoading(false);
        setEolData(null);
      },
    });
  };

  const getChronicsData = () => {
    membersService.fetchMemberChronics(membersService?.getCurrentMember?.patient_id).subscribe({
      next: (res: any) => {
        setChronicsList(res.data.data.chronics);
      },
      error: (error) => {
        console.log(error);
      },
    });
  };

  /************************** */

  // the following code is specifically for millennium for EMR notes
  // this function will fetch the EMR notes which will take user to care-coordination

  const physicianCarePlan = () => {
    if (getClientName() === "Tredence Dev" || getClientName() === "Tredence" || getClientName() === "Mycare" || getClientName() === "Millennium") {
      setMemberProfilePhysicianCarePlanLoader(true);

      if (!membersService?.getCurrentMember?.patient_id) {
        return;
      }

      CareCoordinationService.fetchCarePlanEMRNotes({ patientId: membersService?.getCurrentMember?.patient_id }).subscribe({
        next: (v: any) => {
          const _response = v.data.data;
          setPhysicianCarePlanResponse(_response);
          setMemberProfilePhysicianCarePlanLoader(false);
        },
        error: (e) => {
          console.log(e);
          setMemberProfilePhysicianCarePlanLoader(false);
        },
      });
    }
  };

  const getRegistryDependentProgramsStatus = () => {
    console.log("getRegistryDependentProgramsStatus");
    setRegistryDependentProgramsStatus([]);
    let temp_registryDependentProgramsStatus: any = [];
    const patientId = membersService?.getCurrentMember?.patient_id;
    let linkedProgramList: any = [];
    forEach(memberDetailListRegistryDropDown, (tempProgram: any) => {
      const tempList = tempProgram?.optionalValue?.registryLinkedProgram ? tempProgram?.optionalValue?.registryLinkedProgram : [];
      forEach(tempList, (item: any) => {
        if (item?.careProgramConfiguredProgramName) {
          linkedProgramList.push(item?.careProgramConfiguredProgramName);
        }
      });
    });

    forEach(linkedProgramList, (item: any) => {
      console.log("program ", item);
      memberService.fetchRegistryProgramStatus(patientId, item).subscribe({
        next: (v) => {
          if (v.data.data.status !== 0) {
            temp_registryDependentProgramsStatus.push(item);
            setRegistryDependentProgramsStatus(temp_registryDependentProgramsStatus);
          }
        },
        error: (e: any) => {
          console.log(e);
        },
      });
    });
  };

  const fetchNotifications = () => {
    const page = 1;
    const filter = {
      fromDate: moment.utc(moment(`${moment().format("YYYY-MM-DD")} 23:59:59`).utc()),
    };
    membersService.fetchAllNotifications(page, filter).subscribe({
      next: (v) => {
        let data = v.data.data;
        let notificationsArray = uniqBy([...notificationsData?.notifications, ...data.notifications], "notificationID").sort((a, b) => {
          const dateA = moment(a.notificationDate);
          const dateB = moment(b.notificationDate);
          return dateB.diff(dateA); // Compare in descending order
        });
        setNotificationsData({
          ...notificationsData,
          notifications: notificationsArray,
          totalNotifications: data.readCount + data.unreadCount,
          latest_datetime: get(notificationsArray, "[0].notificationDate"),
          datetime: get(notificationsArray, "[0].notificationDate"),
        });
        setNewNotificationFlag(data.unreadCount > 0);
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  const onStatusChange = (
    caseStatus: string,
    caseStatusReasonTxt: string,
    actionModule: string,
    actionCard: string,
    actionTab: string,
    actionLocation: string,
    actionDescription: string,
    addNote: any
  ) => {
    setShowLoader(true);
    // setStatus(e.target.value);
    membersService.updateStatus(currentMember?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription, caseStatus).subscribe({
      next: (v) => {
        addNote();
        let copyMember = { ...currentMember };
        copyMember.patient_case_status = v.data.data.caseStatus;
        copyMember.case_last_action_date = v.data.data.caseLastActionDate;
        membersService.setCurrentMember = copyMember;
        changeCurrentMember(membersService.getCurrentMember);
        // updateStatus(copyMember, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription);
        //Updating memberList state
        let tempMemberList = [...membersService.getMemberList];
        tempMemberList = tempMemberList.map((item: any) => {
          let mem = cloneDeep(item);
          if (copyMember?.patient_id === mem?.patient_id) {
            mem = {
              ...mem,
              ...copyMember,
            };
          }
          return mem;
        });
        membersService.setMemberList = tempMemberList;
        setShowLoader(false);
      },
      error: (e) => {
        setShowLoader(false);
      },
    });
  };

  const closeCaseModal = (value: any) => {
    setCloseCase(value);
  };

  const updateStatus = (
    patient: any,
    caseStatusReasonTxt: string = "--",
    actionModule: string,
    actionTab: string,
    actionCard: string,
    actionLocation: string,
    actionDescription: string,
    callback?: any,
    registryData?: any
  ) => {
    if (location.pathname === "/member-detail") {
      let currentMember = { ...membersService.getCurrentMember };
      setShowLoader(true);
      membersService.updateStatus(patient?.patient_id, caseStatusReasonTxt, actionModule, actionTab, actionCard, actionLocation, actionDescription).subscribe({
        next: (res) => {
          if (callback) {
            callback(res.data.data.caseStatus, res.data.data.caseLastActionDate);
          }

          currentMember.case_last_action_date = res?.data?.data?.caseLastActionDate;
          currentMember.patient_case_status = res?.data?.data?.caseStatus;
          if (registryData) {
            if (Object.keys(registryData).length > 0) {
              currentMember[registryData.key] = registryData.value;
            }
          }
          membersService.setCurrentMember = currentMember;
          changeCurrentMember(currentMember);
          let tempMemberList = [...membersService.getMemberList];
          tempMemberList = tempMemberList.map((item: any) => {
            let mem = cloneDeep(item);
            if (currentMember?.patient_id === mem?.patient_id) {
              mem = {
                ...mem,
                ...currentMember,
              };
            }
            return mem;
          });
          membersService.setMemberList = tempMemberList;
          setShowLoader(false);
        },
        error: (e) => setShowLoader(false),
      });
    }
  };

  useEffect(() => {
    let listener = () => {
      changeCurrentMember(membersService.getCurrentMember);
    };
    window.addEventListener("member-details:current_member_update", listener);

    return () => {
      window.removeEventListener("member-details:current_member_update", listener);
    };
  }, []);
  useEffect(() => {
    console.log("MemberProfile.useEffect updating currentMember state");
    changeCurrentMember(membersService.getCurrentMember);
  }, [membersService?.getCurrentMember?.patient_id]);

  if (!currentMember) {
    return null;
  }

  const patientStatusBannerDetails = {
    show: (dod && dod !== "--") || ["Deceased", "Disenrolled"].includes(currentMember?.patient_status),
    status: "Deceased",
  };
  if (["Disenrolled"].includes(currentMember?.patient_status) && !(dod && dod !== "--")) {
    patientStatusBannerDetails.status = "Disenrolled";
  }

  const getCurrentPage = (adtFlag?: any) => {
    console.log("MemberProfile.getCurrentPage");
    const adtvalue = adtFlag === "" ? adtFlag : adtFlag || adtState;
    return get(registryDependentMemberListPageStore, adtvalue);
  };

  const changeMember = (right: boolean) => {
    console.log("MemberProfile.changeMember");
    const members = membersService?.getMemberList;
    let idx = findIndex(members, { patient_id: currentMember?.patient_id });
    let nextIdx = idx;
    if (right) {
      nextIdx = idx + 1;

      changeCurrentMember(members[nextIdx]);
      membersService.setCurrentMember = members[nextIdx];
    } else {
      if (idx === -1) {
        nextIdx = members.length - 1;
      } else {
        nextIdx = idx - 1;
      }
      changeCurrentMember(members[nextIdx]);
      membersService.setCurrentMember = members[nextIdx];
    }
    // setLeftBtn(nextIdx > 0 ? false : true);
    // setRightBtn(nextIdx < members.length - 1 ? false : true);
  };

  const newChangeMember = (right: boolean) => {
    const members = membersService?.getMemberList;
    let idx = findIndex(members, { patient_id: currentMember?.patient_id });
    if (right && idx + 1 === members.length) {
      setShowLoader(true);
      nextFunc({
        direction: "right",
        callBack: () => {
          setDirection(right);
          setCount(count + 1);
          setShowLoader(false);
        },
        currentPages: getCurrentPage(),
      });
    } else if (!right && idx === 0) {
      setShowLoader(true);
      nextFunc({
        direction: "left",
        callBack: () => {
          setDirection(right);
          setCount(count + 1);
          setShowLoader(false);
        },
        currentPages: getCurrentPage(),
      });
    } else {
      changeMember(right);
    }
  };

  const speakName = () => {
    const utterance = new SpeechSynthesisUtterance(currentMember?.patient_name);
    utterance.voice = window.speechSynthesis.getVoices()[2];
    window.speechSynthesis.speak(utterance);
  };
  return (
    <Layout
      notifications={notificationsData?.notifications}
      newNotificationFlag={newNotificationFlag}
      setNewNotificationFlag={setNewNotificationFlag}
      members={[currentMember]}
      updateStatus={updateStatus}
      // updateMembers={changeCurrentMember}
    >
      <Spin spinning={showLoader || mainLoader || loadingForOverview} indicator={<HealthemSpinner size={70} />}>
        <div className="member-details">
          <Row className="breadcrumb">
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              {!globalPatientSearchText && (
                <Button
                  type="text"
                  shape="circle"
                  size={"large"}
                  className="back-btn"
                  onClick={() => {
                    if (!location?.state?.from || location?.state?.from === routeMap["members"]) {
                      clearPatientProfileStore();
                    }
                    navigate(location?.state?.from || routeMap["members"]);
                  }}
                >
                  <i className="icon icon-arrow-left"></i>
                </Button>
              )}
              <Breadcrumb>
                {!globalPatientSearchText &&
                  (location?.state?.fromLabel || `Members`)?.split("/")?.map((crumb: string, index: number) => {
                    return (
                      <Breadcrumb.Item
                        onClick={() => {
                          if (!location?.state?.from || location?.state?.from === routeMap["members"]) {
                            clearPatientProfileStore();
                          } else if (index === 0 && location?.state?.fromLabel.includes("Reports")) {
                            setSelectedReport(null);
                          }
                          navigate(location?.state?.from || routeMap["members"]);
                        }}
                        className="bookmarkIcon"
                      >
                        {crumb}
                      </Breadcrumb.Item>
                    );
                  })}
                <Breadcrumb.Item>
                  <span className="w500 clr-textColor">{currentMember?.patient_name}</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            {patientStatusBannerDetails.show && (
              <div className={`patient-deceased ${patientStatusBannerDetails.status}`}>
                Member is <span>{patientStatusBannerDetails.status}</span>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "13rem" }}>
              <p style={{ fontSize: "12px", marginBottom: 0 }}>
                {currentMember?.case_last_action_date
                  ? `Last updated on ${formatDisplayDate(currentMember?.case_last_action_date, "reminderDateActualFormat", "defaultDateFormatWithTime", true)}`
                  : false}
              </p>
            </div>
          </Row>
          <Row>
            <Col span={6}>
              <div className="profile-img-container">
                {membersService.getsingleMember && (
                  <Tooltip
                    overlayInnerStyle={{
                      padding: "12px",
                      borderRadius: "8px",
                      backgroundColor: "#091e42",
                      height: "40px",
                      lineHeight: 1,
                    }}
                    title={leftBtn ? "This is first member" : "See previous member profile"}
                  >
                    <Button
                      type="text"
                      shape="circle"
                      icon={<i className="icon icon-chevron-left" />}
                      size={"middle"}
                      className="profile-img-btn"
                      disabled={leftBtn}
                      onClick={() => newChangeMember(false)}
                    />
                  </Tooltip>
                )}
                {/* 
            <div className="profile-image">
              <Image width={120} height={120} style={{ borderRadius: 60 }} src={data?.memberPersonalInfo?.patientProfileUrl} />
            </div>
             */}
                <div className="profile-name-wrapper">
                  <Tooltip
                    overlayInnerStyle={{
                      padding: "12px",
                      borderRadius: "8px",
                      backgroundColor: "#091e42",
                      height: "40px",
                      lineHeight: 1,
                    }}
                    title={currentMember?.patient_name}
                  >
                    <span className="profile-name">{currentMember?.patient_name}</span>
                  </Tooltip>
                  <Button type="text" size={"large"} className="sound-icon" onClick={speakName} icon={<Icon name="soundIcon" />} />
                </div>

                {membersService.getsingleMember && (
                  <Tooltip
                    overlayInnerStyle={{
                      padding: "12px",
                      borderRadius: "8px",
                      backgroundColor: "#091e42",
                      height: "40px",
                      lineHeight: 1,
                    }}
                    title={rightBtn ? "This is last member" : "See next member profile"}
                  >
                    <Button
                      type="text"
                      shape="circle"
                      icon={<i className="icon icon-chevron-right" />}
                      size={"middle"}
                      className="profile-img-btn"
                      disabled={rightBtn}
                      onClick={() => newChangeMember(true)}
                    />
                  </Tooltip>
                )}
              </div>
            </Col>
            <Col span={"auto"}>
              <div className="member-profile-header">
                {!isCentric && (
                  <div className="profile-name-container">
                    <Button
                      style={{
                        cursor: "default",
                        pointerEvents: "none",
                        border: `1px solid ${patientCurrentStatus?.color}`,
                        color: patientCurrentStatus?.color,
                        backgroundColor: patientCurrentStatus?.backgroundColor,
                      }}
                      shape="round"
                      className={
                        currentMember?.patient_case_status === "Closed" ? `case-status-close-btn ${currentMember?.patient_case_status?.replaceAll(" ", "")?.toLowerCase()}` : `case-status-btn`
                      }
                      size="middle"
                    >
                      {patientCurrentStatus?.label}
                    </Button>
                    {currentMember?.patient_case_status !== "Closed" && (
                      <CanEdit hide={false} wrapperProps={{ style: { display: "inline-block" } }}>
                        <PatientCaseStatusPopUp onStatusChange={onStatusChange} patientCaseStatusOptions={patientCaseStatusOptions} />
                      </CanEdit>
                    )}
                  </div>
                )}

                {/* 
                    //Commenting Patient status to deactivate as per requirement ( enhancement task Id - 14294 | Phase - 1 ) 
                    //After finalizing the complete requirement deactivating patient status will added.
                    
                    <div className="case-details">
                      {
                        currentMember?.patient_case_status !== "Closed" && (
                          <CanEdit hide={false}>
                            <Button className="close-case-btn" size="large" onClick={() => closeCaseModal(true)}>
                              Close Case
                            </Button>
                          </CanEdit>
                        )
                      }
                      {closeCase && (
                        <ModalComponent
                          data={{
                            visible: closeCase,
                            setVisible: closeCaseModal,
                            currentMember: currentMember,
                            changeCurrentMember: changeCurrentMember,
                            updateStatus: updateStatus,
                          }}
                        />
                      )}
                    </div>
                 */}
              </div>
            </Col>
            <Col flex={1}></Col>
            {currentMember?.cadence_id && isMillenium && (
              <Col span={"auto"} style={{ justifyItems: "flex-end", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", paddingBottom: "0.5rem" }}>
                <label style={{ fontSize: 16 }}>Cadence Status:</label>
                <CadenceStatus cadence_status={currentMember?.cadence_status} />
              </Col>
            )}
          </Row>
          <Row gutter={16}>
            {!collapsedProfile && (
              <Col span={6}>
                <Profile
                  tabKeyHandler={callback}
                  currentMember={membersService?.getCurrentMember}
                  setCollapsedProfile={setCollapsedProfile}
                  setShowLoader={setShowLoader}
                  updateStatus={updateStatus}
                  leftBtn={leftBtn}
                  setLeftBtn={setLeftBtn}
                  setRightBtn={setRightBtn}
                  getCurrentPage={getCurrentPage}
                  changeMember={changeMember}
                  direction={direction}
                  count={count}
                  setActiveTabKey={setActiveTabKey}
                />
              </Col>
            )}
            <Col span={collapsedProfile ? 24 : 18}>
              <div className="content">
                {collapsedProfile && (
                  <Tooltip
                    overlayInnerStyle={{
                      padding: "12px",
                      borderRadius: "8px",
                      backgroundColor: "#091e42",
                      height: "40px",
                      lineHeight: 1,
                    }}
                    title="View member profile"
                  >
                    <Button className="profile-expand-btn" icon={<DoubleRightOutlined />} size={"middle"} onClick={() => setCollapsedProfile(false)} />
                  </Tooltip>
                )}
                <div className="member-data">
                  <MemberTabsComponent
                    callback={callback}
                    // overviewChangeHandler={overviewChangeHandler}
                    loadingForOverview={loadingForOverview}
                    setMainLoader={setMainLoader}
                    activeTabKey={activeTabKey}
                    setActiveTabKey={setActiveTabKey}
                  ></MemberTabsComponent>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Spin>
    </Layout>
  );
};

export default MemberProfile;
